import bodymoving from 'lottie-web';

export class AdditionalProductFeatures {
    constructor() {

        this.productFeaturesSection = document.querySelector(".additional-features");
        if (!this.productFeaturesSection) {
            return;
        }

        this.productFeatureItems = this.productFeaturesSection.querySelectorAll(".additional-features-item");
        if (!this.productFeatureItems.length) {
            return;
        }

        // TODO: Uncomment it when the animation files will be ready
        // this.registerEventListeners();

    }

    registerEventListeners() {

        [...this.productFeatureItems].forEach(productFeatureItem => {

            let animatedIconPath = productFeatureItem.hasAttribute("data-animated-icon-path") ? productFeatureItem.dataset.animatedIconPath : '';
            let staticIconContainer = productFeatureItem.querySelector(".additional-features-item__img_static");
            let animatedIconContainer = productFeatureItem.querySelector(".additional-features-item__img_dynamic");
            const direction = 1;

            if (!animatedIconContainer || !animatedIconPath) {
                return;
            }

            let animatedFeatureIcon = bodymoving.loadAnimation({
                container: animatedIconContainer,
                animType: 'svg',
                loop: false,
                autoplay: false,
                path: animatedIconPath
            });

            animatedFeatureIcon.addEventListener('complete', (e) => {
                const direction = productFeatureItem.dataset.hasOwnProperty('direction') ? parseInt(productFeatureItem.dataset.direction) : 0;
                if (direction === -1) {
                    staticIconContainer.classList.remove('transparent');
                }
            });

            productFeatureItem.addEventListener('mouseenter', (e) => {
                staticIconContainer.classList.add('transparent');
                animatedFeatureIcon.setDirection(direction);
                productFeatureItem.dataset.direction = direction;
                animatedFeatureIcon.play();
            });

            productFeatureItem.addEventListener('mouseleave', (e) => {
                animatedFeatureIcon.setDirection(-direction);
                productFeatureItem.dataset.direction = -direction;
                animatedFeatureIcon.play();
            });
        });

    }
}